import { render } from "./SectionContentListDefault.vue?vue&type=template&id=ebb113b8&scoped=true"
import script from "../js/section-content-list-default.js?vue&type=script&lang=js"
export * from "../js/section-content-list-default.js?vue&type=script&lang=js"

import "./SectionContentListDefault.vue?vue&type=style&index=0&id=ebb113b8&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebb113b8"]])

export default __exports__